// ABOUTME: DOM helpers for locating scroll containers.
// ABOUTME: getScrollParent walks up to the nearest actually-scrolling ancestor.

export const getScrollParent = (node) => {
    let el = node?.parentElement;
    while (el) {
        const { overflowY } = window.getComputedStyle(el);
        if ((overflowY === "auto" || overflowY === "scroll") && el.scrollHeight > el.clientHeight) {
            return el;
        }
        el = el.parentElement;
    }
    return document.scrollingElement || document.documentElement;
};
